export default __webpack_public_path__ + "static/media/IMG_9875.d44a5cb6.jpg";